import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';

import { CompleteTypes } from '../types';

const CompleteOptions = [
  {
    label: 'Information check',
    value: CompleteTypes.INFORMATION_CHECK,
  },
  {
    label: 'Finance plan',
    value: CompleteTypes.FINANCE_PLAN,
  },
  {
    label: 'Documents',
    value: CompleteTypes.DOCUMENTS,
  },
  {
    label: 'Questionnaire',
    value: CompleteTypes.INTERVIEW,
  },
  {
    label: 'All',
    value: CompleteTypes.ALL,
  },
];

const key = FilterKey.COMPLETE;
export const getCompleteFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = CompleteOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Complete',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
